module.exports = [{
      plugin: require('/Users/majid/Projects/Telia/engineering-website/node_modules/gatsby-plugin-catch-links/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/majid/Projects/Telia/engineering-website/node_modules/gatsby-remark-autolink-headers/gatsby-browser'),
      options: {"plugins":[]},
    }]
